module.exports = __webpack_public_path__ + "img/by-city2.c10354b5.svg";